export class Location {
  id: string;
  parent: string;
  path: string;

  constructor(id: string, parent: string, path: string) {
    this.id = id;
    this.parent = parent;
    this.path = path;
  }
  public static getDefault(): Location {
    return new Location("", "", "");
  }
}



// WEBPACK FOOTER //
// ./src/modules/WBS/models/Location.tsx